var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.useBanner)?_c('div',{staticClass:"splash"},[_c('img',{staticClass:"splash-img",attrs:{"src":require("../../assets/images/healthtalk.jpg")}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }